export default __webpack_public_path__ + "static/media/roboto-latin-700.2267169e.woff";